var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"digitalstudies-card",attrs:{"no-body":""},on:{"click":_vm.showDigitalStudies}},[_c('b-card-img',{staticClass:"digitalstudies-card-banner",attrs:{"src":_vm.imageSource,"top":""}}),_vm._v(" "),_c('b-card-body',{attrs:{"body-class":"digitalstudies-card-body"}},[_c('b-card-title',[_vm._v(_vm._s(_vm.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }